export const GET_ALL_SCHEDULES = 'GET_ALL_SCHEDULES';
export const ADD_SCHEDULE = 'ADD_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const UPDATE_SCHEDULES = 'UPDATE_SCHEDULES';
export const SET_SCHEDULES = 'SET_SCHEDULES'